import store from "integrations/redux/store"
import { selectActiveToolName } from "plugins/Toolbox/tool-registry"

export const isMapToolActive = () => !!selectActiveToolName()(store.getState())
